export default function ComicPage() {
    return (
        <>
          <section className="">
          <h1> Comic Page</h1>
          </section>
        </>
      )
}